import Coupon from '@/components/caisse/manage-bons/coupon'

export default {
    name: 'confirm-payment',
    components: {
        Coupon
    },
    props: {
        info_caissier: Object,
        user_id: Number,
        compte_id: Number,
        patient: Object,
        total_net_a_payer: Number,
        toggle_payment_state: Number,
        prestations: Array,
        consultation_data: Object,
        etat_paiement: String,
        depot_data: Object,
        info_assurance: Object,
        prestation_data: Object,
        sfe_data: Object,
        prix_apport_social: Number
    },
    data() {
        return {
            total_montant_du: 0,        // === total_net_a_payer
            coupon_remise: 0,
            coupon_pourcent: 0,
            base_remise: 0,

            is_part_payment: false,
            confirm_part_payment: true,
            toggle_net_amount_edition: false,
            toggle_reliquat_edition: false,
            net_paye_is_greater: false,
            deposit_is_less: false,

            is_confirm_payment: true,
            filtered_services: [],
            tmp_prestations: [],
            toggle_coupon: 0,

            is_reliquat: true,
            can_apply_reliquat: false,
            espece_is_less: false,
            reliquat_is_greater: false,
            field_is_empty: false,

            paiement: {
                user_id: 0,
                patient_id: 0,
                prestation: "",
                montant_du: 0,
                montant_recu: 0,
                reliquat: 0,
                reliquat_remis: 0,
                reste_a_payer: 0,
                montant_net_paye: 0,
                compte_id: 0,
                remise: 0,
            },
            save_loading: false

        }
    },

    watch: {
        toggle_payment_state() {
            this.initPayment(this.total_net_a_payer)

            if (!this.isObjectEmpty(this.consultation_data)) {
                // this.consultation_data.prix_vente = this.consultation_data.prix_vente - this.prix_apport_social
                this.base_remise = this.consultation_data.prix_vente
            } else {
                this.base_remise = this.total_net_a_payer
            }
            

            this.is_reliquat = true
            if (this.etat_paiement === 'differer') {
                this.is_reliquat = false
                this.paiement.reste_a_payer = this.total_net_a_payer
            } else {
                this.paiement.reste_a_payer = 0
            }

            this.deposit_is_less = false
            if (this.etat_paiement === 'depot') {
                this.checkDepositSolvency(this.total_net_a_payer)
            }
        }
    },

    computed: {
        paying_bill_state() {
            return this.$store.getters['paying_bill_state']
        },
    },

    mounted() {
        Array.prototype.groupBy = function (key) {
            return this
                .reduce((hash, obj) => {
                    if (obj[key] === undefined) return hash;
                    return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) })
                }, {})
        };
    },

    methods: {
        /**
         * verify solvency by payment on deposit
         * @param {*} montant_du 
         */
        checkDepositSolvency(montant_du) {
            const solde_disponible = (this.depot_data.a_depense == 0)?this.depot_data.montant:this.depot_data.montant_restant

            this.paiement.montant_recu = montant_du

            this.deposit_is_less = false
            if (solde_disponible < montant_du) {
                this.deposit_is_less = true
            }
        },

        toggleEdtion(state) {
            if (state === 'reliquat') {
                this.toggle_reliquat_edition = !this.toggle_reliquat_edition
            } else {
                this.toggle_net_amount_edition = !this.toggle_net_amount_edition
            }
        },

        calcReliquat() {
            this.clearError()
            const amount_is_empty = this.validateStringNotEmpty(this.paiement.montant_recu)
            if (amount_is_empty) {
                this.paiement.montant_net_paye = this.total_montant_du
                return
            }
            this.paiement.montant_recu = this.cleanNumber(this.paiement.montant_recu)

            if (this.paiement.montant_recu > 0) {
                if (this.paiement.montant_recu > this.total_montant_du) {
                    this.paiement.reliquat_remis = this.paiement.montant_recu - this.total_montant_du
                    // this.paiement.reste_a_payer = 0
                } else {
                    this.paiement.reliquat = 0
                    this.paiement.reliquat_remis = 0
                    // this.paiement.reste_a_payer = this.total_montant_du - this.paiement.montant_recu
                }
                this.paiement.montant_net_paye = this.paiement.montant_recu
            } else {
                this.paiement.reliquat = 0
                this.paiement.reliquat_remis = 0
            }
            this.espece_is_less = false
            this.reliquat_is_greater = false
            this.field_is_empty = false
            
        },

        onNetAPayer() {
            this.clearError()
            this.paiement.reliquat_remis = 0
            // this.paiement.reste_a_payer = 0

            const amount_is_empty = this.validateStringNotEmpty(this.paiement.montant_net_paye)
            if (amount_is_empty) {
                return
            }
            this.paiement.montant_net_paye = this.cleanNumber(this.paiement.montant_net_paye)

            if (this.paiement.montant_net_paye > this.paiement.montant_recu) {
                this.net_paye_is_greater = true
                return
            }

            if (this.paiement.montant_net_paye > 0) {
                this.paiement.reliquat_remis = this.paiement.montant_recu - this.paiement.montant_net_paye
                // this.paiement.reste_a_payer = this.total_montant_du - this.paiement.montant_net_paye
            }
        },

        calcResteReliquat() {
            this.paiement.reliquat_remis = parseInt(this.paiement.reliquat_remis)
            if (!Number.isInteger(this.paiement.reliquat_remis)) {
                this.paiement.reliquat_remis = ''
                return
            }

            if (this.paiement.reliquat_remis >= this.paiement.montant_recu) {
                this.reliquat_is_greater = true
                return
            }

            if (this.paiement.reliquat_remis >= 0) {
                if (this.paiement.montant_recu < this.total_montant_du) {
                    this.paiement.montant_net_paye = this.paiement.montant_recu - this.paiement.reliquat_remis
                    // this.paiement.reste_a_payer = this.total_montant_du - this.paiement.montant_net_paye
                } else {
                    let r = this.paiement.montant_recu - this.total_montant_du

                    if (this.paiement.reliquat_remis <= r) {
                        this.paiement.reliquat = r - this.paiement.reliquat_remis
                    } else {
                        this.paiement.reliquat = (this.paiement.montant_recu - this.total_montant_du)
                    }
                }
                
            }
            this.espece_is_less = false
            this.reliquat_is_greater = false
            this.field_is_empty = false
        },

        postponeReliquat() {
            if (this.paiement.reliquat_remis >= this.paiement.montant_recu) {
                this.reliquat_is_greater = true
                return
            }
            this.paiement.reliquat = this.paiement.reliquat_remis
            this.paiement.reliquat_remis = 0
        },

        onConfirm() {
            this.confirm_part_payment = true
            this.is_confirm_payment = true
        },

        checkIfAmountCanBeZero() {
            let can_be_zero = false

            if (this.info_assurance.est_assure) {
                can_be_zero = (this.total_net_a_payer == 0)?true:false
            } else {
                if (this.coupon_remise == this.total_net_a_payer) {
                    can_be_zero = true
                }
            }
            return can_be_zero
        },

        nextToConfirm(v, part_selector) {
            this.clearError()

            const amount_is_empty = this.validateStringNotEmpty(this.paiement.montant_recu)
            if (amount_is_empty) {
                this.field_is_empty = true
                return;
            }
            this.paiement.montant_recu = this.cleanNumber(this.paiement.montant_recu)

            const can_be_zero = this.checkIfAmountCanBeZero()
            if (!can_be_zero && this.paiement.montant_recu == 0) {
                this.field_is_empty = true
                return;
            }

            if (this.paiement.montant_net_paye > this.paiement.montant_recu) {
                this.net_paye_is_greater = true
                return;
            }

            // TODO
            if (!can_be_zero) {
                if (this.paiement.reliquat_remis >= this.paiement.montant_recu) {
                    this.reliquat_is_greater = true
                    return;
                }
    
                if ((this.paiement.montant_recu < this.total_montant_du) || (this.paiement.montant_net_paye < this.total_montant_du)) {
                    this.is_part_payment = true
                }
            }
            

            const part_confirm = document.getElementById(part_selector);
            if (this.is_part_payment && !part_confirm) {
                return;
            }

            if (this.is_part_payment && !part_confirm.checked) {
                this.confirm_part_payment = false
                return;
            }

            this.setPrestation()
            if (this.is_part_payment && part_confirm.checked) {
                let reste = 0
                this.filtered_services.forEach(service => {
                    if (service.data_type != 'apport_social') {
                        if (this.paying_bill_state == 3) {
                            reste += this.total_net_a_payer - service.net_paye
                        } else {
                            reste += (service.prix_vente - service.net_paye)
                        }
                        
                        this.paiement.reste_a_payer = reste
                    }
                });
            }
            this.is_reliquat = !v
            // this.can_apply_reliquat = v
        },

        setPrestation() {
            this.tmp_prestations = []

            if (this.paying_bill_state != 2) {      // Different du cas différé
                this.sortPrestation()
            }

            this.prestations.forEach(prestation => {
                const tmp_prestation = {
                    uid: (this.paying_bill_state !== '')?prestation.uid:'',
                    data_type: prestation.data_type,
                    parent_id: prestation.parent_id,
                    id: prestation.id,
                    operation_id: prestation.operation_id,
                    libelle: prestation.libelle,
                    nom_acte: prestation.nom_acte,
                    prix: prestation.prix,
                    prix_clinique: prestation.prix_clinique,
                    prix_vente: prestation.prix_vente,
                    group_taxation: prestation?.group_taxation,
                    taxe_specifique: prestation?.taxe_specifique,
                    net_paye: prestation.net_paye,
                    prix_assure_clinique: prestation.prix_assure_clinique,
                    base_assurance: prestation.base_assurance,
                    part_assureur: prestation.part_assureur,
                    taux_couverture: prestation.taux_couverture,
                    coupon_remise: prestation.coupon_remise,
                    qte: prestation.qte,
                    est_exclu: prestation.est_exclu,
                    is_vente_caisse: prestation?.is_vente_caisse
                }
                this.tmp_prestations.push(tmp_prestation)
            });

            console.log(">> tmp prest",this.tmp_prestations);
            
            
            if (!this.isObjectEmpty(this.consultation_data)) {
                this.tmp_prestations.unshift(this.consultation_data)
            }

            
            if (this.etat_paiement === 'differer') {
                this.filtered_services = []

                this.tmp_prestations.forEach((prestation, index) => {
                    if (prestation.libelle === 'Apport social') {
                        this.tmp_prestations[index]['data_type'] = 'apport_social'
                    }
                });

                this.filtered_services = this.tmp_prestations
                return
            }

            this.filterPrestation()
            
        },

        /**
         * Sort list of services by descending order
         */
        sortPrestation() {
            this.prestations.sort( (a, b) => a.prix_vente - b.prix_vente )
        },

        /**
         * Verifier s'il ya Apport social
         */
        checkApportSocial() {
            let apport_social = 0
            this.tmp_prestations.forEach((prestation, index) => {
                if (prestation.libelle === 'Apport social' || prestation.data_type == 'apport_social') {
                    this.tmp_prestations[index]['data_type'] = 'apport_social'
                    apport_social = prestation.prix_clinique
                }
            });
            return apport_social
        },

        /** 
         * Filter list of services accordingly to the paid ones
        */
        filterPrestation() {
            const apport_social = this.checkApportSocial()

            this.filtered_services = []
            let montant_net_paye = this.paiement.montant_net_paye
            if (apport_social > 0) {
                montant_net_paye += apport_social
            }
            
            this.tmp_prestations.forEach((prestation, index) => {
                if (montant_net_paye > 0 || (this.coupon_pourcent == 100 && montant_net_paye == 0)  || this.total_net_a_payer == 0) {
                    if ((montant_net_paye > prestation.prix_vente) || (montant_net_paye == 0 && this.total_net_a_payer == 0)) {
                        if (prestation.data_type != 'apport_social') {
                            this.tmp_prestations[index]['net_paye'] = prestation.prix_vente
                            montant_net_paye = montant_net_paye - prestation.prix_vente
                        }
                    } else {
                        this.tmp_prestations[index]['net_paye'] = montant_net_paye
                        montant_net_paye = 0
                    }
                    this.filtered_services = [...this.filtered_services, this.tmp_prestations[index]]
                } 
                else {
                    if (montant_net_paye == 0 && prestation.data_type == 'apport_social') {
                        this.filtered_services = [...this.filtered_services, this.tmp_prestations[index]]
                    }
                    // this.filtered_services = [...this.filtered_services, this.tmp_prestations[index]]
                    
                    // const can_be_zero = this.checkIfAmountCanBeZero()
                    // // if (can_be_zero && montant_net_paye == 0) {
                    // //     this.filtered_services = [...this.filtered_services, this.tmp_prestations[index]]
                    // // }
                }
            });
            
        },

        setPrestationUid() {
            this.filtered_services.forEach((prestation, index) => {

                if (this.paying_bill_state !== '') {
                    this.filtered_services[index]['uid'] = prestation.uid
                    return;
                } 

                const tm = new Date()
                let tmp_uid = prestation.libelle
                tmp_uid = tmp_uid.replace(" ", "_")
                tmp_uid = tmp_uid.replace("/", "_")
                tmp_uid = tmp_uid.toLowerCase()+''+tm.getTime()
                tmp_uid = tmp_uid.replace("  ", "_")
                tmp_uid = tmp_uid.replace(" ", "_")
                this.filtered_services[index]['uid'] = tmp_uid
            });
        },

        groupPrestatation(prestations) {
            const tmp_grouped_operations = prestations.groupBy('data_type')
            let grouped_operations = []
          
            let taux_couverture = (this.paiement.info_assurance.est_assure == 1)?this.paiement.info_assurance.taux_couverture:''
            
            for (const key in tmp_grouped_operations) {
                if (key == 'consommable_bon' || key == 'apport_social') {
                    taux_couverture = ''
                }
                const tmp_group = {
                    data_type: key,
                    taux_couverture: (taux_couverture == '')?tmp_grouped_operations[key][0]['taux_couverture']:taux_couverture,
                    libelle: this.setLibellePrestation(key),
                    prestations: tmp_grouped_operations[key]
                }
                grouped_operations.push(tmp_group)
            }

            this.paiement.remise = 0
            grouped_operations.forEach((group, index) => {
                let total_prix_by_group = 0
                let total_base_assurance_by_group = 0
                let total_pac_by_group = 0
                let total_part_assureur_by_group = 0
                let total_net_paye_by_group = 0
                let total_remise_by_group = 0
                let total_prix_vente_by_group = 0
                let group_taxe_specifique = 0
                group.prestations.forEach((prestation, p_index) => {
                    group.prestations[p_index].groupe_taxation = ''
                    if (prestation.group_taxation && Object.prototype.hasOwnProperty.call(prestation.group_taxation, 'slug')) {
                        group.prestations[p_index].groupe_taxation = this.capitalizeFirstLetter(prestation.group_taxation.slug)
                    }
                    
                    let qte = 0
                    qte = prestation.qte

                    let pu = 0
                    if (this.can_set_pac && this.paiement.info_assurance.est_assure && prestation.data_type != 'consommable_bon') {
                        pu = prestation.prix_assure_clinique
                    } else {
                        pu = (prestation.prix_clinique > prestation.base_assurance)?prestation.prix_clinique:prestation.base_assurance
                    }
                    
                    total_prix_by_group += (pu * qte)

                    total_net_paye_by_group += prestation.net_paye

                    if (prestation.coupon_remise) {
                        total_remise_by_group += prestation.coupon_remise
                    }
                    
                    total_prix_vente_by_group += (prestation.data_type != 'apport_social')?prestation.prix_vente:(-prestation.prix_vente)
                    group_taxe_specifique += prestation.taxe_specifique

                    if (this.paiement.info_assurance.est_assure == 1) {
                        if (prestation.base_assurance > 0) {
                            total_base_assurance_by_group += (parseInt(prestation.base_assurance) * qte)
                        }

                        if (prestation.prix_assure_clinique > 0) {
                            total_pac_by_group += ( parseInt(prestation.prix_assure_clinique) * prestation.qte)
                        }
                        
                        total_part_assureur_by_group += prestation.part_assureur
                    }
                });
                grouped_operations[index].total_prix_by_group = total_prix_by_group
                grouped_operations[index].total_net_paye_by_group = total_net_paye_by_group
                grouped_operations[index].total_remise_by_group = total_remise_by_group
                grouped_operations[index].total_base_assurance_by_group = total_base_assurance_by_group
                grouped_operations[index].total_pac_by_group = total_pac_by_group
                grouped_operations[index].total_part_assureur_by_group = total_part_assureur_by_group
                grouped_operations[index].total_prix_vente_by_group = total_prix_vente_by_group
                grouped_operations[index].group_taxe_specifique = group_taxe_specifique

                this.paiement.remise += total_remise_by_group
            });
            

            return grouped_operations
        },

        handlePayment(selector) {
            const confirm = document.getElementById(selector);
            if (!confirm.checked) {
                this.is_confirm_payment = false
                return
            }

            if (this.etat_paiement === 'differer') {
                this.setPrestation()
            }

            this.setPrestationUid()

            this.filtered_services.forEach((service, index) => {
                if (service.data_type == 'apport_social') {
                    this.filtered_services[index].libelle += " - "+this.consultation_data.libelle
                }
            });

            let info_patient = {
                nom_patient: this.patient.nom_patient,
                sexe: this.patient.sexe,
                telephone: this.patient.telephone_mobile,
                num_dossier: this.patient.num_dossier
            }
            
            this.paiement.info_caissier = this.info_caissier
            this.paiement.info_patient = info_patient
            this.paiement.prestation = this.prestation_data.libelle
            this.paiement.montant_du = this.total_montant_du
            this.paiement.total_du = this.total_net_a_payer
            this.paiement.user_id = this.user_id
            this.paiement.patient_id = this.patient.id
            this.paiement.compte_id = this.compte_id
            this.paiement.prestations = this.filtered_services
            this.paiement.info_assurance = this.info_assurance
            this.paiement.type_operation = 1        // Recette
            this.paiement.etat_paiement = this.etat_paiement
            this.paiement.paying_bill_state = this.paying_bill_state
            this.paiement.is_with_deposit = (!this.isObjectEmpty(this.depot_data))
            this.paiement.depot_data = this.depot_data
            this.paiement.sfe_aib = this.sfe_data.info_aib.slug
            this.paiement.sfe_libelle_aib = this.sfe_data.info_aib.libelle
            this.paiement.sfe_impot_aib = this.sfe_data.impot_aib
            this.paiement.remise_percentage = parseFloat(this.coupon_pourcent).toFixed(2)

            this.save_loading = true

            const grouped_prestations = this.groupPrestatation(this.paiement.prestations)
            console.log(grouped_prestations);
            console.log("PAYMENT: ",this.paiement);            
            
            const dispatch_action = (this.paying_bill_state === '' || this.paying_bill_state === 0)?'storeOperationCaisse':'updateOperationCaisse'
            this.$store.dispatch(dispatch_action, this.paiement).then((response) => {
                if (response.success) {
                    this.paiement.grouped_prestations = grouped_prestations

                    if (this.prestation_data.data_type == 'bon_consultation') {
                        let consultation_info = {}
                        this.paiement.prestations.forEach((prestation) => {
                            if (prestation.data_type === 'bon_consultation') {
                                consultation_info = prestation
                            }
                        });

                        const data = {
                            data_type: this.prestation_data.data_type,
                            etat_paiement: this.etat_paiement,
                            consultation_info: consultation_info,
                            paiement: this.paiement, 
                            ticket_info: response.data
                        }

                        this.$emit('emitBonConsultation', data)
                    } else if (this.prestation_data.data_type == 'analyse' || this.prestation_data.data_type == 'examen') {
                        const data = {
                            data_type: this.prestation_data.data_type,
                            etat_paiement: this.etat_paiement,
                            prestations: this.paiement.prestations,
                            paiement: this.paiement, 
                            ticket_info: response.data
                        }
                        this.$emit('emitBonMedical', data)
                    } else if (this.prestation_data.data_type == 'pharmacie' || this.prestation_data.data_type == 'acte') {
                        const data = {
                            data_type: this.prestation_data.data_type,
                            etat_paiement: this.etat_paiement,
                            prestations: this.paiement.prestations,
                            paiement: this.paiement, 
                            ticket_info: response.data
                        }
                        this.$emit('emitVente', data)
                    } else if (this.prestation_data.data_type == '') {
                        const data = {
                            data_type: this.prestation_data.data_type,
                            etat_paiement: this.etat_paiement,
                            prestations: this.paiement.prestations,
                            paiement: this.paiement, 
                            ticket_info: response.data
                        }
                        this.$emit('emitUpdate', data)
                    }
                    
                    this.$refs.cfrm_payment.click()
                } else {
                    if (response.code == 500) {
                        // TODO
                    }
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
            })
        },

        backToPayment() {
            this.is_reliquat = true
        },

        clearError() {
            this.is_part_payment = false
            this.net_paye_is_greater = false
            this.reliquat_is_greater = false
        },

        goToCoupon() {
            this.toggle_coupon = (this.toggle_coupon == 0)?1:0

            this.initPayment(this.total_net_a_payer)
        },

        applyCoupon(coupon_data) {
            let montant_du_remise = 0
            this.coupon_pourcent = coupon_data.coupon_pourcent
            
            if (!this.isObjectEmpty(this.consultation_data)) {
                // Update Prix de vente consultation
                this.consultation_data.prix_vente = this.consultation_data.prix_clinique - coupon_data.remise
                this.consultation_data.coupon_remise = coupon_data.remise

                this.prestations.forEach(prestation => {
                    if (prestation.libelle != 'Apport social') {
                        montant_du_remise += prestation.prix_vente
                    } else {
                        montant_du_remise -= prestation.prix_vente
                    }
                });
                montant_du_remise += coupon_data.montant_du
            } else {
                this.prestations.forEach((prestation, index) => {

                    let valeur_ajoutee = 0
                    if (prestation.taxe_specifique > 0) {
                        valeur_ajoutee = parseFloat( prestation.taxe_specifique * (1 + (prestation.group_taxation.taux / 100)) ).toFixed(0)
                        valeur_ajoutee = parseInt(valeur_ajoutee)
                    }
                    this.prestations[index]['coupon_remise'] = Math.ceil((coupon_data.coupon_pourcent * prestation.prix_clinique) / 100) * prestation.qte
                    const remise_by_prestation = (parseInt( ((100 - coupon_data.coupon_pourcent) / 100) * prestation.prix_clinique ) * prestation.qte) + valeur_ajoutee
                    this.prestations[index]['prix_vente'] = remise_by_prestation
                });

                montant_du_remise = coupon_data.montant_du
            }
            
            this.initPayment(montant_du_remise)
            this.coupon_remise = coupon_data.remise

            // If payment is by deposit, then check back the solvency
            if (this.etat_paiement == 'depot') {
                this.checkDepositSolvency(montant_du_remise)
            }
        },

        initPayment(montant_du) {
            this.paiement = {
                user_id: 0,
                patient_id: 0,
                prestation: "",
                montant_du: 0,
                montant_recu: 0,
                reliquat: 0,
                reliquat_remis: 0,
                reste_a_payer: 0,
                montant_net_paye: 0,
                compte_id: 0,
            }
            
            if (this.etat_paiement !== 'differer') {
                this.paiement.montant_net_paye = montant_du
            }
            
            this.total_montant_du = montant_du
        }
    }
}


